import css from "./ReportCard.module.scss";
import Pill from "../atoms/Pill";
import { useEffect, useState } from "react";

export default function ReportCard({
    title,
    valuePrev,
    valueNow,
    change,
    type = "number",
    dontCompare,
    smallIcon,
    handleDropdown,
    dates,
}) {
    const [changeIndicator, setChangeIndicator] = useState();
    const [color, setColor] = useState();
    const [icon, setIcon] = useState();

    useEffect(() => {
        if (!dontCompare) {
            if (change > 0) {
                setColor("green");
                setIcon("fas fa-arrow-up");
            } else if (change < 0) {
                setColor("red");
                setIcon("fas fa-arrow-down");
            } else {
                setColor("amber");
                setIcon("fas fa-arrows-alt-v");
            }

            setChangeIndicator(change > 0 ? `${change}%` : `${change}%`);
        }
    }, [change]);

    const rangeOptions = [
        { label: "30 Days", value: 30 },
        { label: "15 Days", value: 15 },
        { label: "10 Days", value: 10 },
        { label: "5 Days", value: 5 },
        { label: "Last Day", value: 1 },
    ];

    const [range, setRange] = useState(rangeOptions[0]);

    const handleRange = (selected) => {
        setRange(selected.target.value);
        handleDropdown(selected.target.value);
    };

    return (
        <div className={css["card"]}>
            {/* <header className={css.header}> */}
                <h3 className={css["title"]}>{title}</h3>
                <i className={`fad fa-${smallIcon} ${css["title-icon"]}`} />
                {/* <select
                    className={css["select"]}
                    value={range}
                    onChange={handleRange}
                >
                    {rangeOptions.map((option) => (
                        <option className={css["option"]} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select> */}
            {/* </header> */}

            <div className={css["value-box"]}>
                <p className={css["value"]}>
                    <span className={css["type"]}>
                        {type === "dollar" && "$"}
                    </span>
                    {type == "dollar" ? valueNow?.toFixed(2) : valueNow}
                    <span className={css["type"]}>
                        {type === "percent" && "%"}
                    </span>
                </p>
                <Pill
                    label={changeIndicator}
                    color={color}
                    variant="secondary"
                    iconLeft={`fas ${icon}`}
                />
            </div>

            {!dontCompare && dates?.from && dates?.to ? (
                <div>
                    <p className={css["time-frame"]}>
                        Previous:{" "}
                        {type == "dollar"
                            ? `$${valuePrev?.toFixed(2)}`
                            : valuePrev}{" "}
                    </p>
                    <p className={css["time-frame"]}>
                        Period:{" "}
                        {new Date(dates?.from).toLocaleDateString("en-us", {
                            day: "numeric",
                            month: "short",
                        })}{" "}
                        —{" "}
                        {new Date(dates?.to).toLocaleDateString("en-us", {
                            day: "numeric",
                            month: "short",
                        })}
                    </p>
                </div>
            ) : null}

            {dontCompare && <p className={css["time-frame"]}>*All Time</p>}
        </div>
    );
}
